<template>
  <div class="home">
    <ProgressStep step=3 />
    <p class="stepReminder">Étape 3/4</p>
    <h1>Distance école / foyer familiale</h1>
    <div class="inputFrame">
      <label for="location">Indique ici la distance d’éloignement entre le domicile familial et l’école.</label>
      <div class="locatonFrame">
        <input
         list="dep"
          id="location"
          v-model="$store.state.location"
          @keyup="isLocationValid()"
          @input="isLocationValid()"
          class="inputFocus"
          :class="{ 'inputError' : !locationIsValid }"
          placeholder="Département ou n° de département"
          autocomplete="off"
        >
        <datalist id="dep">
          <option
            v-for="(dep, i) in depList"
            :key="i"
            :value="dep"
          >
          </option>
        </datalist>
        <span>
          <img src="assets/icon/recherche.svg" alt="Rechercher le département">
        </span>
      </div>
    </div>
    <div class="inputFrame">
      <p>Éloignement des études</p>
      <label for="range1" class="radioFrame">
        <input input type="radio" id="range1" v-model="$store.state.range" value="0">
        <span>0 à 29 km</span>
      </label>
      <label for="range2" class="radioFrame">
        <input input type="radio" id="range2" v-model="$store.state.range" value="30">
        <span>30 à 249 km</span>
      </label>
      <label for="range3" class="radioFrame">
        <input input type="radio" id="range3" v-model="$store.state.range" value="250">
        <span>250 km ou +</span>
      </label>
    </div>
    <button @click="goToNext()" class="submit-button" :style="disabled">
      <span class="insivibleSpacer"></span>
      <span>Étape suivante</span>
      <img src="assets/icon/fleche-droite.svg" alt="Étape suivante">
    </button>
    <button @click="$router.push({ name: 'Etape-2' })" class="submit-button-back">
      <img src="assets/icon/fleche-gauche.svg" alt="Étape précédente">
      <span>Étape précédente</span>
    </button>
  </div>
</template>

<script>
// @ is an alias to /src
import ProgressStep from '@/components/ProgressStep.vue'

export default {
  name: 'Etape3',
  components: {
    ProgressStep
  },
  data () {
    return {
      locationIsValid: true,
      depList: [
        "1 - Ain",
        "2 - Aisne",
        "3 - Allier",
        "4 - Alpes-de-Haute-Provence",
        "5 - Hautes-Alpes",
        "6 - Alpes-Maritimes",
        "7 - Ardèche",
        "8 - Ardennes",
        "9 - Ariège",
        "10 - Aube",
        "11 - Aude",
        "12 - Aveyron",
        "13 - Bouches-du-Rhône",
        "14 - Calvados",
        "15 - Cantal",
        "16 - Charente",
        "17 - Charente-Maritime",
        "18 - Cher",
        "19 - Corrèze",
        "21 - Côte-d'Or",
        "22 - Côtes-d'Armor",
        "23 - Creuse",
        "24 - Dordogne",
        "25 - Doubs",
        "26 - Drôme",
        "27 - Eure",
        "28 - Eure-et-Loir",
        "29 - Finistère",
        "2A - Corse-du-Sud",
        "2B - Haute-Corse",
        "30 - Gard",
        "31 - Haute-Garonne",
        "32 - Gers",
        "33 - Gironde",
        "34 - Hérault",
        "35 - Ille-et-Vilaine",
        "36 - Indre",
        "37 - Indre-et-Loire",
        "38 - Isère",
        "39 - Jura",
        "40 - Landes",
        "41 - Loir-et-Cher",
        "42 - Loire",
        "43 - Haute-Loire",
        "44 - Loire-Atlantique",
        "45 - Loiret",
        "46 - Lot",
        "47 - Lot-et-Garonne",
        "48 - Lozère",
        "49 - Maine-et-Loire",
        "50 - Manche",
        "51 - Marne",
        "52 - Haute-Marne",
        "53 - Mayenne",
        "54 - Meurthe-et-Moselle",
        "55 - Meuse",
        "56 - Morbihan",
        "57 - Moselle",
        "58 - Nièvre",
        "59 - Nord",
        "60 - Oise",
        "61 - Orne",
        "62 - Pas-de-Calais",
        "63 - Puy-de-Dôme",
        "64 - Pyrénées-Atlantiques",
        "65 - Hautes-Pyrénées",
        "66 - Pyrénées-Orientales",
        "67 - Bas-Rhin",
        "68 - Haut-Rhin",
        "69 - Rhône",
        "70 - Haute-Saône",
        "71 - Saône-et-Loire",
        "72 - Sarthe",
        "73 - Savoie",
        "74 - Haute-Savoie",
        "75 - Paris",
        "76 - Seine-Maritime",
        "77 - Seine-et-Marne",
        "78 - Yvelines",
        "79 - Deux-Sèvres",
        "80 - Somme",
        "81 - Tarn",
        "82 - Tarn-et-Garonne",
        "83 - Var",
        "84 - Vaucluse",
        "85 - Vendée",
        "86 - Vienne",
        "87 - Haute-Vienne",
        "88 - Vosges",
        "89 - Yonne",
        "90 - Territoire de Belfort",
        "91 - Essonne",
        "92 - Hauts-de-Sein",
        "93 - Seine-Saint-Denis",
        "94 - Val-de-Marne",
        "95 - Val-d'Oise",
        "971 - Guadeloupe",
        "972 - Martinique",
        "973 - Guyane",
        "974 - La Réunion",
        "976 - Mayot"
      ],
      depListFiltered: [],
      disabled: 'background-color: #C3C4CA'
    }
  },
  mounted () {
    this.$store.state.location !== null && this.isLocationValid()
  },
  methods: {
    goToNext () {
      if (this.$store.state.location !== null && this.$store.state.location !== '' && this.depList.includes(this.$store.state.location)) {
        // this.$store.state.location = this.$store.state.location.split(' - ')[0]
        this.$router.push({ name: 'Etape-4' })
      } else {
        this.locationIsValid = false
      }
    },
    isLocationValid () {
      if (this.$store.state.location !== null && this.$store.state.location !== '' && this.depList.includes(this.$store.state.location)) {
        this.locationIsValid = true
        this.disabled = ''
      } else {
        this.locationIsValid = false
        this.disabled = 'background-color: #C3C4CA'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .inputFrame {
    margin-top: 30px;
    p {
      margin: 0;
    }
  }
  .radioFrame {
    accent-color: var(--color-secondary);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    cursor: pointer;
    input {
      width: 20px;
      height: 20px;
      margin: 14px 0;
    }
    span {
      margin-left: 23px;
      font-weight: 400;
      font-size: 17px;
      letter-spacing: 0.4px;
      color: var(--color-text);
      text-align: left;
      padding: 14px 0;
      width: 100%;
    }
  }
  .locatonFrame {
    display: flex;
    align-items: center;
    width: calc(100% + 10.68px);
    margin-top: 10px;
    input {
      border: solid 1px #9FA7A7;
      border-radius: 3px;
      padding: 11px 13px;
      width: calc(100% - 28px);
      font-weight: 400;
      font-size: 17px;
      color: #000000;
      text-align: left;
    }
    span {
      width: 10.68px;
      color: var(--color-text);
      transform: translateX(-32px) translateY(2px);
      pointer-events: none;
    }
  }
  #location::-webkit-calendar-picker-indicator {
    opacity: 0;
  }
  #dep {
    max-height:250px;
    overflow:auto;
  }
  @media screen and (min-width: 585px) {
    
  }
</style>
